export class FormularioPerguntaPostModel {
    id: number = 0;
    texto: string = '';
    tipoPergunta: number = 1;
    ordem: number = 0;
    obrigatoria: boolean = false;
    opcoes?: string;
    escalaMinimo?: number;
    escalaMaximo?: number;
}

export class FormularioPostModel {
    id: number = 0;
    nome: string = '';
    descricao?: string;
    ativo: boolean = true;
    perguntas: FormularioPerguntaPostModel[] = [];
}

export class FormularioPerguntaGetModel {
    id: number = 0;
    texto: string = '';
    tipoPergunta: number = 1;
    ordem: number = 0;
    obrigatoria: boolean = false;
    opcoes?: string;
    escalaMinimo?: number;
    escalaMaximo?: number;
}

export class FormularioGetModel {
    id: number = 0;
    nome: string = '';
    descricao?: string;
    ativo: boolean = true;
    dataCriacao: Date = new Date();
    dataAlteracao?: Date;
    perguntas: FormularioPerguntaGetModel[] = [];
}

export class FormularioListModel {
    id: number = 0;
    nome: string = '';
    descricao?: string;
    ativo: boolean = true;
    dataCriacao: Date = new Date();
    dataCriacaoFormatada: string = '';
    quantidadePerguntas: number = 0;
}

export class ModeloFormularioGetModel {
    id: number = 0;
    nome: string = '';
    descricao?: string;
    perguntas: FormularioPerguntaGetModel[] = [];
}

export class ModeloFormularioListModel {
    id: number = 0;
    nome: string = '';
    descricao?: string;
    quantidadePerguntas: number = 0;
}

export class RespostaFormularioPostModel {
    formularioPerguntaId: number = 0;
    resposta?: string;
}

export class FormularioPreenchidoPostModel {
    id: number = 0;
    formularioId: number = 0;
    clienteId: number = 0;
    respostas: RespostaFormularioPostModel[] = [];
}

export class RespostaFormularioGetModel {
    id: number = 0;
    formularioPerguntaId: number = 0;
    perguntaTexto: string = '';
    resposta?: string;
}

export class FormularioPreenchidoGetModel {
    id: number = 0;
    formularioId: number = 0;
    formularioNome: string = '';
    clienteId: number = 0;
    clienteNome: string = '';
    dataPreenchimento: Date = new Date();
    dataAlteracao?: Date;
    respostas: RespostaFormularioGetModel[] = [];
}

export class FormularioPreenchidoListModel {
    id: number = 0;
    formularioNome: string = '';
    dataPreenchimento: Date = new Date();
    dataPreenchimentoFormatada: string = '';
}

export enum TipoPergunta {
    TextoCurto = 1,
    TextoLongo = 2,
    EscolhaUnica = 3,
    EscolhaMultipla = 4,
    SimNao = 5,
    Escala = 6,
    Data = 7,
    Numero = 8
}

export const TipoPerguntaLabel: { [key: number]: string } = {
    [TipoPergunta.TextoCurto]: 'Texto Curto',
    [TipoPergunta.TextoLongo]: 'Texto Longo',
    [TipoPergunta.EscolhaUnica]: 'Escolha Única',
    [TipoPergunta.EscolhaMultipla]: 'Escolha Múltipla',
    [TipoPergunta.SimNao]: 'Sim/Não',
    [TipoPergunta.Escala]: 'Escala',
    [TipoPergunta.Data]: 'Data',
    [TipoPergunta.Numero]: 'Número'
};
